<template>
  <div class="site-section services-wrap">
    <div class="container">
      <div class="services-heading">
        <h3>O que fazemos</h3>
      </div>
      <div class="row no-gutters">
        <div class="col-lg-3 col-md-6">
          <div class="service">
            <div class="service-body">
              <h3 class="service-title">Correção estática por tomografia</h3>
              <!-- <b-button variant="outline-warning" size="sm" >
                Saiba mais
              </b-button> -->
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="service">
            <div class="service-body">
              <h3 class="service-title">Regularização de dados pré-stack</h3>
              <!-- <b-button variant="outline-warning" size="sm">
                Saiba mais
              </b-button> -->
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="service">
            <div class="service-body">
              <h3 class="service-title">Análise de velocidades</h3>
              <!-- <b-button variant="outline-warning" size="sm">
                Saiba mais
              </b-button> -->
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="service">
            <div class="service-body">
              <h3 class="service-title">Common Reflection Surface (CRS)</h3>
              <!-- <b-button variant="outline-warning" size="sm">
                Saiba mais
              </b-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Servicos",
};
</script>

<style>

.services-heading {
  text-align: center;
  padding-bottom: 2rem;
  font-weight: 300;
  color: #fbc02d;
  text-transform: uppercase;
  font-size: 1.3rem;
}

.site-section {
  padding: 2.5em 0;
}
@media (min-width: 768px) {
  .site-section {
    padding: 5em 0;
  }
}
.site-section.site-section-sm {
  padding: 4em 0;
}

.site-section-heading {
  padding-bottom: 20px;
  margin-bottom: 0px;
  position: relative;
  font-size: 2.5rem;
}
@media (min-width: 768px) {
  .site-section-heading {
    font-size: 3rem;
  }
}

.services-wrap .service {
  padding: 20px 30px;
  border: 1px solid #a5a6a6;
  border-right: none;
  position: relative;
}
@media (max-width: 1199.98px) {
  .services-wrap .service {
    border: 1px solid #a5a6a6;
    margin-bottom: 30px;
  }
}

.services-wrap .service .number {
  position: absolute;
  right: 10px;
  top: 10px;
  font-weight: 400;
  font-family: "Oswald", sans-serif;
  color: #dcdcdc;
}

.services-wrap .service .service-icon {
  position: relative;
  margin-left: 20px;
}
.services-wrap .service .service-icon:before {
  position: absolute;
  content: "";
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: -1;
  left: -20px;
  border-top: 40px solid transparent;
  border-bottom: 40px solid transparent;
  border-right: 40px solid #ff5e15;
}
.services-wrap .service .service-icon > span {
  color: #000;
  font-size: 4rem;
}

.services-wrap .service .service-body .service-title {
  font-size: 1.5rem;
  color: #000;
  font-weight: 400;
}

.services-wrap .service .service-body p {
  font-size: 15px;
}

.services-wrap [class^="col-"]:last-child .service {
  border-right: 1px solid #a5a6a6;
}

.section-title {
  color: #fff;
  font-weight: 300;
}

.section-title strong {
  font-weight: 700;
}

.section-subtitle {
  font-weight: 300;
  color: #ff5e15;
  text-transform: uppercase;
  font-size: 1.3rem;
}
</style>
